export const getYoutubeVideoId = (url) => {
  if (!url) return null;
  
  // Regular expression to match various YouTube URL formats, including shorts
  const regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
  const match = url.match(regex);
  
  return match ? match[1] : null;
}; 
